export default "__VITE_ASSET__D61N8WDS__"